module.exports = __webpack_public_path__ + "static/media/Group 2.8682bd0d.svg";